import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../core/providers/ThemeProvider';
import './styles.css';

const ThemeContent = ({ currentTheme, onThemeChange }) => {
  const { t } = useTranslation('settings');
  const { currentTheme: activeTheme } = useTheme();

  const themes = [
    { id: 'light', label: t('pages.preferences.theme.options.light') },
    { id: 'dark', label: t('pages.preferences.theme.options.dark') },
    { id: 'system', label: t('pages.preferences.theme.options.system') }
  ];
  
  const handleThemeChange = (newTheme) => {
    try {
      console.log('ThemeContent: Saving theme preference:', newTheme);
      // Enregistrer la préférence de thème, ThemeProvider le détectera automatiquement
      onThemeChange(newTheme);
    } catch (error) {
      console.error('ThemeContent: Error saving theme preference:', error);
    }
  };

  return (
    <div className="preferences-section">
      <h2 className="preferences-section-title">
        {t('pages.preferences.theme.description')}
      </h2>
      <div className="preferences-theme-list">
        {themes.map((themeOption) => (
          <button
            key={themeOption.id}
            className={`preferences-theme-option ${
              currentTheme === themeOption.id ? 'preferences-theme-option-selected' : ''
            }`}
            onClick={() => handleThemeChange(themeOption.id)}
          >
            <span className="preferences-option-label">{themeOption.label}</span>
            {currentTheme === themeOption.id && (
              <span className="preferences-theme-check">✓</span>
            )}
          </button>
        ))}
      </div>
      <div className="theme-info">
        {currentTheme === 'system' && (
          <p className="theme-system-info">
            {t('pages.preferences.theme.systemInfo', { 
              detected: activeTheme === 'dark' ? 
                t('pages.preferences.theme.options.dark') : 
                t('pages.preferences.theme.options.light') 
            })}
          </p>
        )}
      </div>
    </div>
  );
};

export default ThemeContent; 